import { Component, DestroyRef, OnInit, effect, inject, signal } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { Router, ActivatedRoute } from '@angular/router';
import { Constants } from 'src/app/utils/constants';
import { MenuItemSortHelper } from 'src/app/utils/menuItemSort.helper';
import { MenuItem } from '../../bo/menuItem';
import { Site } from 'src/app/bo/site';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';

@Component({
  selector: 'app-site-setup',
  templateUrl: './site-setup.component.html',
  styleUrls: ['./site-setup.component.scss'],
  standalone: false
})
export class SiteSetupComponent implements OnInit {
  siteId: number;
  Constants = Constants;
  isLoaded = signal(false);
  currentSite: Site = undefined;
  

  arrayMenu: MenuItem[] = [
    {
      translateId: 'CONTROL_POINT.CONTROL_POINT',
      translatedName:"",
      activeClass: 'active',
      tab: 5,
      routePath: 'control-points'
    },
    {
      translateId: 'KPI.KPI',
      translatedName: "",
      activeClass: 'active',
      tab: 8,
      routePath: 'kpi'
    },
    {
      translateId: 'GLOBAL.OPERATORS',
      translatedName: "",
      activeClass: 'active',
      tab: 2,
      routePath: 'operators'
    },
    // {
    //   translateId: 'GLOBAL.SITE_SETUP_SHEET_TEMPLATE',
    //   translatedName: "",
    //   activeClass: 'active',
    //   tab: 4
    // },
    {
      translateId: 'GLOBAL.UTILISATEURS',
      translatedName: "",
      activeClass: 'active',
      tab: 3,
      routePath: 'users'
    },
    {
      translateId: 'GLOBAL.ZONES',
      translatedName: "",
      activeClass: 'active',
      tab: 1,
      routePath: 'zones'
    },
    {
      translateId: 'GLOBAL.SITE_SETUP_HIERARCHIE',
      translatedName: "",
      activeClass: 'active',
      tab: 6,
      routePath: 'hierarchy'

    },
    {
      translateId: 'GLOBAL.SISMOGRAPH',
      translatedName: "",
      activeClass: 'active',
      tab: 9,
      routePath: 'sismograph'
    },
    {
      translateId: 'GLOBAL.WORKFLOWS',
      translatedName: "",
      activeClass: 'active',
      tab: 10,
      routePath: 'workflows'
    },
    {
      translateId: 'GLOBAL.CONF_ANALYSE',
      translatedName: "",
      activeClass: 'active',
      tab: 11,
      routePath: 'analysis-config'
    },
    {
      translateId: 'ROCK_TYPE.ROCK_TYPE',
      translatedName: "",
      activeClass: 'active',
      tab: 12,
      routePath: 'rock-types'
    },
    {
      translateId: 'MODALE_DONNEE_SUIVI.EQUIPEMENTS',
      translatedName: "",
      activeClass: 'active',
      tab: 13,
      routePath: 'equipments'
    },
    {
      translateId: 'GLOBAL.DXF',
      translatedName: "",
      activeClass: 'active',
      tab: 14,
      routePath: 'dxf'
    },
    {
      translateId: 'GLOBAL.COST',
      translatedName: "",
      activeClass: 'active',
      tab: 15,
      routePath: 'cost'
    },
    // {
    //   translateId: 'MINE_TRACKER.TITLE',
    //   translatedName: "",
    //   activeClass: 'active',
    //   tab: 16,
    //   routePath: 'mine-tracker'
    // },
    {
      translateId: 'HOLE_TOLERANCE.TITLE',
      translatedName: "",
      activeClass: 'active',
      tab: 17,
      routePath: 'hole-tolerance'
    },
    {
      translateId: 'SHIFT_CONFIG.TITLE',
      translatedName: "",
      activeClass: 'active',
      tab: 18,
      routePath: 'shifts'
    },
    {
      translateId: 'DRILL_PAUSE_REASON.TITLE',
      translatedName: "",
      activeClass: 'active',
      tab: 19,
      routePath: 'drill-pause-reasons'
    },
    {
      translateId: 'FEATURES.MENU_TITLE',
      translatedName: "",
      activeClass: 'active',
      tab: 20,
      routePath: 'features'
    }
  ]

  
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    public utilService: UtilisateurService,
    private readonly fonctionsService: FonctionsService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
    ) {
    this.currentSite = this.utilService.currentSite();
    effect(() => {
      const site = this.utilService.currentSite();
      this.currentSite = site;
      if (site && this.siteId && site.siteId !== this.siteId) {
        const currentPath = this.route.firstChild?.snapshot.url[0]?.path || 'zones';
        this.router.navigate(['/site-setup', site.siteId, currentPath]);
      }
    });
   }

  async ngOnInit() {
    // Get siteId from route params
    this.siteId = +this.route.snapshot.params['siteId'];
    
    // Wait for sites to be loaded before syncing service with URL
    if (this.utilService.listeSites.length > 0) {
      // Sites already loaded - sync immediately
      this.syncServiceWithUrl(this.siteId);
    } else {
      // Sites not loaded yet - wait for them
      toObservable(this.utilService.isInitialize).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(isInitialized => {
        if (isInitialized && this.siteId) {
          this.syncServiceWithUrl(this.siteId);
        }
      });
    }
    
    // Watch for route parameter changes (when navigating between different sites)
    this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      const newSiteId = +params['siteId'];
      if (newSiteId && newSiteId !== this.siteId) {
        this.siteId = newSiteId;
        // Only sync if sites are loaded
        if (this.utilService.listeSites.length > 0) {
          this.syncServiceWithUrl(newSiteId);
        }
      }
    });
    
    // Sort and translate menu items list
    this.arrayMenu = await new MenuItemSortHelper(this.arrayMenu).translateAndSortMenu();

    // Wait for sort is finish
    setTimeout(() => {
      this.isLoaded.set(true);
    }, 5);
  }
  
  private syncServiceWithUrl(urlSiteId: number) {
    if (urlSiteId && this.utilService.currentSite()?.siteId !== urlSiteId) {
      const siteFromUrl = this.utilService.listeSites.find(s => s.siteId === urlSiteId);
      if (siteFromUrl) {
        this.utilService.setCurrentSite(siteFromUrl);
      } else {
        // If site not found, redirect to current site or first available site
        const fallbackSite = this.utilService.currentSite() || this.utilService.listeSites[0];
        if (fallbackSite) {
          const currentPath = this.route.firstChild?.snapshot.url[0]?.path || 'zones';
          this.router.navigate(['/site-setup', fallbackSite.siteId, currentPath]);
        }
      }
    }
  }


}





